import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Drawer } from 'antd';
import {
  MenuUnfoldOutlined, ReadOutlined, ReconciliationOutlined,
  MenuFoldOutlined, BankOutlined, CalendarOutlined, FileDoneOutlined,
  CalculatorOutlined, ShoppingCartOutlined, ShopOutlined, RocketOutlined, BarcodeOutlined,
  DashboardOutlined, UploadOutlined, DiffOutlined, UserOutlined,
  BarsOutlined, AuditOutlined, WhatsAppOutlined, GiftOutlined, CarryOutOutlined, HomeOutlined,
  FileTextOutlined, FolderViewOutlined, SignalFilled, SettingOutlined, ControlOutlined, PhoneOutlined,
  CustomerServiceOutlined,IdcardOutlined, UsergroupAddOutlined, EnvironmentOutlined,CrownOutlined
} from '@ant-design/icons';
import DialogContentText from '@material-ui/core/DialogContentText';
import { NavLink, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { useHistory } from 'react-router-dom';
// Import other components
import ScannerIcon from '@material-ui/icons/Scanner';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import BallotIcon from '@material-ui/icons/Ballot';
import AssignmentLateRoundedIcon from '@material-ui/icons/AssignmentLateRounded';
import FaceIcon from '@material-ui/icons/Face';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { Menu as MaterialMenu, FormControl } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Box from "@material-ui/core/Box";
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import CategoryRoundedIcon from '@material-ui/icons/CategoryRounded';
import AssignmentRoundedIcon from '@material-ui/icons/AssignmentRounded';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import FilterIcon from '@material-ui/icons/Filter';
import { BsFillMicFill } from 'react-icons/bs';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import GroupChatWidgetIcon from './ChatWidgetIcon';
import GroupChat from '../components/GroupChat';
import Routes from '../routes';
import HttpService from '../services/httpService';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import { setUserDetails } from '../redux/actions/userAction';
import { logoutUser } from '../redux/actions/leadSourceActions';
import { connect } from 'react-redux';
// Import logos
import decorpotLogo from '../assets/img/org/deco_white_logo.png';
import decorpotLogoSmall from '../assets/img/org/logo-small.png';
import { ROLENAME } from '../utils/index';
import { IoMail } from "react-icons/io5";
const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;
const ITEM_HEIGHT = 48;


const useStyles = makeStyles({
  input: {
    color: "white",
    borderBottom: "1px solid #fff",
  },
  inputLabel: {
    color: "#aca9a9 !important",
  },
  icon: {
    color: 'white',
  },
  changePasswordButton: {
    backgroundColor: 'white',
    color: '#2c2e3e',
    marginRight: 10,
    marginLeft: 10,
    marginTop: 10,
    padding: 5,
    borderRadius: '50px',
    width: '100px',
    height: '25px',
    fontSize: '8px',
    "&:hover": {
      backgroundColor: "#F47E46",
      color: '#FFF2EB'
    }
  },
  // Add route transition styles here
  routeContentWrapper: {
    opacity: 1,
    transition: 'opacity 0.3s ease-in-out',
  },
  fadeExit: {
    opacity: 0,
  },
  fadeEnterActive: {
    opacity: 1,
  }
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Sidebar = React.memo((props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const classes = useStyles();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { userDetails } = useSelector(state => state.user)
  const [sidebarItems, setSidebarItems] = useState([])
  const [changePasswordModal, setChangePasswordModal] = useState(false)
  const [expcenters, setExpcenters] = useState([]);
  const [locations, setLocations] = useState([]);
  const [defaultLocation, setDefaultLocation] = useState(userDetails.selectedLocation);
  const [defaultExpCenter, setDefaultExpCenter] = useState(userDetails.selectedExpCenter);
  const [password, setPassword] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  })

  const [showPassword, setShowPassword] = useState(false)
  const [isPasswordShort, setIsPasswordShort] = useState(false);
  const [showChatComponent, setShowChatComponent] = useState(false);
  const [isConfirmPasswordMatched, setIsConfirmPasswordMatched] = useState(true);
  const [isPasswordValidated, setIsPasswordValidated] = useState({
    hasNumber: false,
    hasUpperCase: false,
    hasLowerCase: false,
    hasSpecialChar: false
  });
  const [passwordStrength, setPasswordStrength] = useState("");
  const [passwordStrengthColor, setPasswordStrengthColor] = useState("red");
  const [daysRemainingToChangePassword, setDaysRemainingToChangePassword] = useState(90 - (userDetails.DaysRemainingToChangePassword || 0));
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [openKeys, setOpenKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState(['dashboard']);
  const [profileModal, setProfileModal] = useState(false);
  const [experienceCenter, setSexperienceCenterId] = useState([])
  const [logoutConfirmModal, setLogoutConfirmModal] = useState(false);
  const [assistantManager, setAssistantManager] = useState("");
  const [departmentName, setDepartmentName] = useState('');
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMobileOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    getAsideItems();
    getLocationList();
    expireSession();
    fetchUserData();
    getDepartments()
    return () => {
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line
  }, []);

  // Set initially selected key based on current path
  useEffect(() => {
    updateSelectedKeysFromPath(location.pathname);
  }, [location.pathname, sidebarItems]);
  const getDepartments = async () => {
    try {
      const response = await HttpService.getDepartments();
  
      const departments = response?.data || [];
  
      // Target department ID
      const targetId = userDetails?.departmentId;
  
      // Filter department by ID
      const targetDepartment = departments.find(dep => dep._id === targetId);
  
      if (targetDepartment) {
        // console.log("Department Name:", targetDepartment.name);
  
        // Example: Set department name in state
        setDepartmentName(targetDepartment.name);
      } else {
        console.log("Department not found with ID:", targetId);
      }
  
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };
  // Function to update selected keys based on current path
  const updateSelectedKeysFromPath = (pathname) => {
    // Find the menu item with a matching URL
    let foundKey = null;
    let parentKey = null;

    // Recursive function to search through menu items
    const findMenuItemByUrl = (items, parent = null) => {
      for (const item of items) {
        // Check if this item's URL matches the current path
        if (item.url && pathname === item.url) {
          foundKey = item.key;
          parentKey = parent;
          return true;
        }

        // Check if pathname starts with this URL (for nested routes)
        if (item.url && pathname.startsWith(item.url)) {
          foundKey = item.key;
          parentKey = parent;
        }

        // If this item has submenus, search them too
        if (item.subMenu && item.subMenu.length > 0) {
          const found = findMenuItemByUrl(item.subMenu, item.key);
          if (found) return true;
        }
      }
      return false;
    };

    // Search through the sidebar items
    if (sidebarItems.length > 0) {
      findMenuItemByUrl(sidebarItems);
    }

    // If found, update the selected key
    if (foundKey) {
      setSelectedKeys([foundKey]);
      if (parentKey) {
        setOpenKeys(prevOpenKeys => {
          if (!prevOpenKeys.includes(parentKey)) {
            return [...prevOpenKeys, parentKey];
          }
          return prevOpenKeys;
        });
      }
    }
  };

  const fetchUserData = async () => {
    try {
      const response = await HttpService.getUserById(userDetails._id);

      if (response.data.cacheClearRequired && localStorage.length > 0) {
        const updateUserCache = await HttpService.updateUserCacheById(userDetails._id);
        if (updateUserCache.data = 'ok') {
          localStorage.clear();
        }
      }

      let MyLastPasswordCreationDate = new Date(response.data.LastPasswordCreationDate);
      let CurrentDate = new Date();
      let timeDifference = CurrentDate.getTime() - MyLastPasswordCreationDate.getTime();
      let DaysRemainingToChangePassword = 90 - (Math.floor(timeDifference / (1000 * 60 * 60 * 24)));

      setDaysRemainingToChangePassword(DaysRemainingToChangePassword);
      setSexperienceCenterId(response.data?.experienceCenterId)
      setAssistantManager(response.data?.assistantManagerId?.name)
      if (DaysRemainingToChangePassword < 1) {
        localStorage.clear();
        history.push('/');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const expireSession = () => {
    let version = "2.7";
    if (!localStorage.getItem('VERSION_KEY')) {
      localStorage.setItem('VERSION_KEY', version);
    } else if (localStorage.getItem('VERSION_KEY') !== version) {
      localStorage.removeItem('TOKEN_KEY');
      window.location.reload();
      localStorage.setItem('VERSION_KEY', version);
    } else if (localStorage.getItem('VERSION_KEY') === version) {
      localStorage.setItem('VERSION_KEY', version);
    }
  };

  const getAsideItems = async () => {
    props.setLoading(true);
    try {
      const response = await HttpService.getAsideItems();
      setSidebarItems(response.data);

      // Update selected keys after fetching sidebar items
      updateSelectedKeysFromPath(location.pathname);
    } catch (error) {
      console.error(error);
      props.setSnackInfo(error?.response?.data?.message ?? "Something Went Wrong", "error");
      if (error?.response?.data?.success === false) {
        localStorage.clear();
        props.setUserDetails({});
        history.push('/');
      }
    }
    props.setLoading(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const logout = async () => {
    localStorage.clear();
    let reload = userDetails.roles.find(role => role.name === 'TeleCaller' || role.name === 'TeleCallerAssistantManager');
    handleClose(); 
    setLogoutConfirmModal(false); 
    dispatch(logoutUser());
    props.setUserDetails({});
    history.push('/');
    reload && window.location.reload();
  };

  // Handle submenu open/close
  const handleOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  // Handle menu item selection
  const handleMenuClick = (e) => {
    setSelectedKeys([e.key]);
  };

  const checkPasswordStrength = (password) => {
    const strengthLevels = {
      veryWeak: /^(?=.*[a-z])/,
      weak: /^(?=.*[a-z])(?=.*[A-Z])/,
      ok: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      strong: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])/,
      veryStrong: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,})/,
    };

    if (strengthLevels.veryStrong.test(password)) {
      setPasswordStrengthColor('darkgreen');
      return 'Very Strong';
    } else if (strengthLevels.strong.test(password)) {
      setPasswordStrengthColor('lightgreen');
      return 'Strong';
    } else if (strengthLevels.ok.test(password)) {
      setPasswordStrengthColor('blue');
      return 'Ok';
    } else if (strengthLevels.weak.test(password)) {
      setPasswordStrengthColor('orange');
      return 'Weak';
    } else {
      setPasswordStrengthColor('red');
      return 'Very Weak';
    }
  };

  const changePassword = async () => {
    props.setLoading(true);

    const isPasswordValid = validatePassword(password.newPassword);

    if (!isPasswordValid) {
      props.setSnackInfo('Password should contain atleast one Uppercase, Lowercase, Numeric & Special character !,@,#,$,~,`,_,-,*,&,^,%', "error");
      props.setLoading(false);
      return null;
    }

    try {
      if (password.newPassword !== password.confirmPassword)
        return props.setSnackInfo('Passwords Do Not Match', "error");

      let response = await HttpService.changePassword({ password: password.currentPassword, newPassword: password.newPassword });
      props.setSnackInfo(response?.data?.message, "success");

      setPassword({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
      });

      setChangePasswordModal(false);
      localStorage.clear();
      history.push('/');

    } catch (error) {
      console.error(error);
      props.setSnackInfo(error?.response?.data?.message ?? "Something went Wrong", "error");
    }
    props.setLoading(false);
  };

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$~`_\-*&^%])[A-Za-z\d!@#$~`_\-*&^%]{8,}$/;
    return regex.test(password);
  };

  const validatePassword2 = (password) => {
    const numberRegex = /\d/;
    const upperCaseRegex = /[A-Z]/;
    const lowerCaseRegex = /[a-z]/;
    const specialCharRegex = /[!@#$~`_\-*&^%]/;

    const hasNumber = numberRegex.test(password);
    const hasUpperCase = upperCaseRegex.test(password);
    const hasLowerCase = lowerCaseRegex.test(password);
    const hasSpecialChar = specialCharRegex.test(password);

    return {
      hasNumber,
      hasUpperCase,
      hasLowerCase,
      hasSpecialChar
    };
  };

  const changeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === 'newPassword') {
      const passwordStrength = checkPasswordStrength(value);
      setPasswordStrength(passwordStrength);
      const passwordValidation = validatePassword2(value);
      setIsPasswordValidated(passwordValidation);

      if (value.length < 8) {
        setIsPasswordShort(true);
      } else {
        setIsPasswordShort(false);
      }

      if (value !== password.confirmPassword) {
        setIsConfirmPasswordMatched(false);
      } else {
        setIsConfirmPasswordMatched(true);
      }
    } else if (name === 'confirmPassword') {
      if (password.newPassword !== value) {
        setIsConfirmPasswordMatched(false);
      } else {
        setIsConfirmPasswordMatched(true);
      }
    }
    setPassword({ ...password, [e.target.name]: value });
  };

  const handleCancelForChangePassword = () => {
    setIsPasswordShort(false);
    setIsConfirmPasswordMatched(true);
    setPassword({
      ...password,
      currentPassword: "",
      newPassword: "",
      confirmPassword: ""
    });
    setChangePasswordModal(false);
  };

  const getLocationList = async () => {
    try {
      const response = await HttpService.getLocationList();
      let userLocation = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < userDetails.locationId.length; j++) {
          if (response.data[i]._id === userDetails.locationId[j]._id) {
            userLocation.push({
              _id: userDetails.locationId[j]._id,
              name: userDetails.locationId[j].name
            });
          }
        }
      }
      setLocations(userLocation);
      setDefaultLocation(userDetails.selectedLocation);
      getExperienceCenterByLocation(userDetails.selectedLocation);
    } catch (error) {
      console.log(error);
    }
  };

  const getExpCenterByCity = async (cityid) => {
    setDefaultLocation(cityid);
    await getExperienceCenterByLocation(cityid);
  };

  const getExperienceCenterByLocation = async (locid) => {
    try {
      const response = await HttpService.getExpericenCentersByLocation(locid);
      let userExpCenters = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < userDetails.experienceCenterId.length; j++) {
          if (userDetails.experienceCenterId[j] === response.data[i]['_id']) {
            userExpCenters.push({
              name: response.data[i]['name'],
              _id: response.data[i]['_id']
            });
          }
        }
      }
      setExpcenters(userExpCenters);
    } catch (error) {
      console.log(error);
    }
  };

  const handleexpcenter = (e) => {
    setDefaultExpCenter(e.target.value);
    props.setUserDetails({
      ...userDetails,
      selectedExpCenter: e.target.value,
      selectedLocation: defaultLocation
    });
    setTimeout(() => {
      window.location.reload(false);
    }, 1000);
  };

  const handleChatIconClick = () => {
    setShowChatComponent(!showChatComponent);
  };

  const handleCloseChat = () => {
    setShowChatComponent(false);
  };

  const iconComponents = {
    "DashboardOutlined": DashboardOutlined,
    'SettingOutlined': SettingOutlined,
    'ControlOutlined': ControlOutlined,
    'EqualizerIcon': EqualizerIcon,
    'CalendarOutlined': CalendarOutlined,
    'UserOutlined': UserOutlined,
    'AssignmentRoundedIcon': AssignmentRoundedIcon,
    'CategoryRoundedIcon': CategoryRoundedIcon,
    'CalculatorOutlined': CalculatorOutlined,
    'ReadOutlined': ReadOutlined,
    'BarsOutlined': BarsOutlined,
    'ReconciliationOutlined': ReconciliationOutlined,
    'DiffOutlined': DiffOutlined,
    'ShopOutlined': ShopOutlined,
    'ShoppingCartOutlined': ShoppingCartOutlined,
    'GiftOutlined': GiftOutlined,
    'RocketOutlined': RocketOutlined,
    'HomeOutlined': HomeOutlined,
    'FileDoneOutlined': FileDoneOutlined,
    "SupervisedUserCircleIcon": SupervisedUserCircleIcon,
    "FolderSharedIcon": FolderSharedIcon,
    "LocalLibraryIcon": LocalLibraryIcon,
    "LiveHelpIcon": LiveHelpIcon,
    "AddShoppingCartIcon": AddShoppingCartIcon,
    "CloudDownloadIcon": CloudDownloadIcon,
    "BallotIcon": BallotIcon,
    "CarryOutOutlined": CarryOutOutlined,
    "SignalFilled": SignalFilled,
    "UploadOutlined": UploadOutlined,
    'AuditOutlined': AuditOutlined,
    'PhoneOutlined': PhoneOutlined,
    'ConfirmationNumber': ConfirmationNumberIcon,
    'RecentActorsIcon': RecentActorsIcon,
    'FilterIcon': FilterIcon,
    'CustomerServiceOutlined': CustomerServiceOutlined,
    'BsFillMicFill': BsFillMicFill,
    'WhatsAppOutlined': WhatsAppOutlined
  };

  const replaceDatePlaceholders = (url) => {
    const datePattern = /\$\{moment\(\).subtract\((\d+), 'months'\).format\('YYYY-MM-DD'\)\}\/\$\{moment\(\).add\((\d+), 'days'\).format\('YYYY-MM-DD'\)\}/;

    return url.replace(datePattern, (match, subtractMonths, addDays) => {
      const startDate = moment().subtract(parseInt(subtractMonths), 'months').format('YYYY-MM-DD');
      const endDate = moment().add(parseInt(addDays), 'days').format('YYYY-MM-DD');
      return `${startDate}/${endDate}`;
    });
  };

  const renderMenuItems = (menuItems, parentUrl = '') => {
    let isRoleSE = userDetails.roles.some(role => role.name === "Sales User");
    const localData = JSON.parse(localStorage.getItem('disableMenu')) || {};

    // Here check localData is an object and not null 
    if (typeof localData !== 'object' || localData === null) {
      localData = {};
    }
    const isDisabled = Object.values(localData).some(value => value > 0);
    const disabled = isRoleSE && isDisabled;

    menuItems.sort((a, b) => a.priority - b.priority);

    return menuItems.map(menuItem => {
      if (menuItem.isActive) {
        let url = menuItem.url;

        // Replace date placeholders in the URL
        url = replaceDatePlaceholders(url);

        const IconComponent = iconComponents[menuItem.Icon];

        if (menuItem.subMenu && menuItem.subMenu.length > 0) {
          return (
            <SubMenu
              key={menuItem.key}
              icon={IconComponent ? <IconComponent /> : null}
              title={menuItem.label}
              disabled={disabled}
            >
              {renderMenuItems(menuItem.subMenu, url)}
            </SubMenu>
          );
        } else {
          return (
            <Menu.Item key={menuItem.key} icon={IconComponent ? <IconComponent /> : null} disabled={disabled}>
              {disabled ? (
                <span style={{ color: 'gray', cursor: 'not-allowed' }}>{menuItem.label}</span>
              ) : (
                <NavLink to={url} activeClassName="ant-menu-item-selected">{menuItem.label}</NavLink>
              )}
            </Menu.Item>
          );
        }
      }
      return null;
    });
  };

  const { canAccess } = userDetails.canAccess ? userDetails.canAccess[0] : { canAccess: [] };

  // Render sidebar content - used in both desktop and mobile views
  const SidebarContent = () => (
    <>
      <div className="logo">
        {collapsed ?
          <img className="decorpot_logo_small" src={decorpotLogoSmall} alt="decorpot logo" /> :
          <img className="decorpot_logo" src={decorpotLogo} alt="decorpot logo" style={{ maxWidth: '130%' }} />
        }
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
        onClick={handleMenuClick}
      >
        {canAccess && canAccess.length !== 0 ?
          renderMenuItems(canAccess) :
          <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
            <NavLink to="/dashboard" activeClassName="ant-menu-item-selected">
              Dashboard
            </NavLink>
           
          </Menu.Item>
        }
           {userDetails?.roles?.find(role =>
          role.name != ROLENAME.ProjectManager ||
          role.name === ROLENAME.SiteInspector
        ) && (
         <Menu.Item key="scan-code" icon={<DashboardOutlined />}>
         <NavLink to="/scan-piece" activeClassName="ant-menu-item-selected">
            Scan Barcode
            </NavLink>
            </Menu.Item>
        )}

        {userDetails?.roles?.find(role =>
          role.name === ROLENAME.Admin ||
          role.name === ROLENAME.CHM_Manager ||
          role.name === ROLENAME.CHM_User ||
          role.name === ROLENAME.TeleCallerManager
        ) && (
            <Menu.Item key="CHM-Service-Ticket" icon={<FolderSharedIcon />}>
              <a href="https://decorpot.raiseaticket.com/support/#/newticket" target="_blank" rel="noopener noreferrer">
                Create Service Ticket
              </a>
            </Menu.Item>
          )}
      </Menu>
    </>
  );

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Desktop Sidebar */}
      {!isMobile && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          width={300}
          className="desktop-sidebar"
        >
          <SidebarContent />
        </Sider>
      )}

      {/* Mobile Drawer */}
      {isMobile && (
        <Drawer
          placement="left"
          closable={false}
          onClose={toggleDrawer}
          visible={mobileOpen}
          bodyStyle={{ padding: 0 }}
          width={300}
        >
          <div style={{ backgroundColor: '#001529', height: '100%' }}>
            <SidebarContent />
          </div>
        </Drawer>
      )}

      <Layout className="site-layout">
        <Header className="site-layout-background" style={{
          padding: 0,
          color: "white",
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {isMobile ? (
              <Button
                type="text"
                icon={<MenuUnfoldOutlined style={{ color: '#fff' }} />}
                onClick={toggleDrawer}
                style={{ padding: '0 24px', fontSize: '18px', color: '#fff' }}
              />
            ) : (
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={toggleCollapse}
                style={{ padding: '0 24px', fontSize: '18px', color: '#fff' }}
              />
            )}
          </div>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '0 16px',
            flexWrap: 'wrap',
            justifyContent: 'flex-end'
          }}>
            {!isMobile && (
              <div style={{ display: "flex", marginRight: 15 }}>
                <span style={{ fontSize: isMobile ? '12px' : 'inherit' }}>
                  Days Remaining: {daysRemainingToChangePassword}
                </span>
                <Button
                  className={classes.changePasswordButton}
                  onClick={() => setChangePasswordModal(true)}
                  variant="contained"
                >
                  Change Password
                </Button>
              </div>
            )}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ marginRight: 10 }}>
                {userDetails?.name}
              </div>
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                <MoreVertIcon style={{ color: "#fff" }} />
              </IconButton>
            </div>
          </div>
        </Header>

        <Content
          className="site-layout-background"
          style={{
            margin: '16px',
            padding: isMobile ? 12 : 24,
            minHeight: 280,
            overflow: 'auto',
            transition: 'all 0.3s ease' // Add smooth transition
          }}
        >
          <div className="route-content-wrapper" style={{
            opacity: 1,
            transition: 'opacity 0.3s ease-in-out'
          }}>
            <Routes {...props} />
          </div>
        </Content>
        {/* User Menu */}
        <MaterialMenu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '25ch',
            },
          }}
        >
          <MenuItem onClick={() => {
            handleClose();
            setProfileModal(true);
          }}>
            Profile
          </MenuItem>
         
           <MenuItem onClick={() => setChangePasswordModal(true)}>
            Change password
           </MenuItem>

          <MenuItem key={'logout'} onClick={() => {
            handleClose();
            setLogoutConfirmModal(true);
          }}>
             Logout
          </MenuItem>
        </MaterialMenu>

        {/* Chat Widget */}
        {!showChatComponent && <GroupChatWidgetIcon onClick={handleChatIconClick} />}
        <Dialog
          open={showChatComponent}
          onClose={handleCloseChat}
          PaperProps={{
            style: {
              position: 'fixed',
              bottom: '70px',
              right: '20px',
              margin: 0,
              width: isMobile ? '90%' : '30%',
              maxHeight: '60%',
              borderRadius: '10px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            },
          }}
          hideBackdrop
          disableEnforceFocus
          disableEscapeKeyDown
        >
          <GroupChat onClose={handleCloseChat} />
        </Dialog>
        <Dialog
          open={changePasswordModal}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={'xs'}
          onClose={() => setChangePasswordModal(false)}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">{"Change Password"}</DialogTitle>
          <DialogContent>
            <div style={{ display: "flex", flexDirection: "column", }}>

              <TextField style={{ marginBottom: 10 }} label="Current Password" name="currentPassword" variant="outlined" type="password" value={password.currentPassword} onChange={changeHandler} />

              {password.newPassword.length > 0 && isPasswordShort && <p style={{ color: 'red' }}>*Password must be at least 8 characters long</p>}

              <TextField style={{ marginBottom: 10, marginTop: 5 }} label="New Password" name="newPassword" variant="outlined" type="password" value={password.newPassword} onChange={changeHandler} />


              {password.newPassword.length > 0 && <p style={{ color: passwordStrengthColor, fontWeight: 900, marginBottom: 5 }}>{passwordStrength}</p>}

              {password.confirmPassword.length > 0 && !isConfirmPasswordMatched && <p style={{ color: 'red' }}>*Passwords do not match</p>}

              <TextField style={{ marginBottom: 10, marginTop: 5 }} label="Confirm Password" name="confirmPassword" variant="outlined" type="password" value={password.confirmPassword} onChange={changeHandler} />

              {
                password.newPassword.length > 0 &&
                <>

                  <div style={{ display: 'flex', flexDirection: 'row' }}>

                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                      <p style={{ marginRight: 10, fontSize: 14 }}>Atleast 1 Uppercase</p>
                      {isPasswordValidated.hasUpperCase ? <CheckCircleIcon style={{ verticalAlign: 'middle', color: 'green', fontSize: 30 }} /> : <span style={{ color: 'red' }}>: No</span>}
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <p style={{ marginRight: 10, fontSize: 14 }}>Atleast 1 Lowercase</p>
                      {isPasswordValidated.hasLowerCase ? <CheckCircleIcon style={{ verticalAlign: 'middle', color: 'green', fontSize: 30 }} /> : <span style={{ color: 'red' }}>: No</span>}
                    </div>

                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>

                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                      <p style={{ marginRight: 10, fontSize: 14 }}>Atleast 1 Number</p>
                      {isPasswordValidated.hasNumber ? <CheckCircleIcon style={{ verticalAlign: 'middle', color: 'green', fontSize: 30 }} /> : <span style={{ color: 'red' }}>: No</span>}
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <p style={{ marginRight: 10, fontSize: 14 }}>Atleast 1 Special Character</p>
                      {isPasswordValidated.hasSpecialChar ? <CheckCircleIcon style={{ verticalAlign: 'middle', color: 'green', fontSize: 30 }} /> : <span style={{ color: 'red' }}>: No</span>}
                    </div>

                  </div>

                </>

              }

            </div>
          </DialogContent>
          <DialogActions>

            <Button onClick={() => handleCancelForChangePassword()} color="primary">
              Cancel
            </Button>

            <Button onClick={changePassword} color="primary" disabled={password.currentPassword == "" || password.newPassword == "" || password.confirmPassword == "" || isPasswordShort || !isConfirmPasswordMatched || ['Very Weak', 'Weak'].includes(passwordStrength)}>
              Proceed
            </Button>

          </DialogActions>
        </Dialog>
         <Dialog
            open={profileModal}
            TransitionComponent={Transition}
            onClose={() => setProfileModal(false)}
            maxWidth="sm"
            fullWidth
          >
        <DialogTitle  style={{ fontWeight: 'bold' }}>Profile Details</DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <UserOutlined style={{ fontSize: '20px', marginRight: '16px' ,color:"#f47e46"}} />
              <div>
                <div style={{ fontWeight: 'bold' }}>Name</div>
                <div>{userDetails?.name}</div>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <IoMail style={{ fontSize: '20px', marginRight: '16px' ,color:"#f47e46"}} />
              <div>
                <div style={{ fontWeight: 'bold' }}>Email</div>
                <div>{userDetails?.email}</div>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <PhoneOutlined style={{ fontSize: '20px', marginRight: '16px',color:"#f47e46" }} />
              <div>
                <div style={{ fontWeight: 'bold' }}>Mobile Number</div>
                <div>{userDetails?.mobile || 'Not available'}</div>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <BankOutlined style={{ fontSize: '20px', marginRight: '16px' ,color:"#f47e46"}} />
              <div>
                <div style={{ fontWeight: 'bold' }}>Department</div>
                <div>{departmentName || 'Not available'}</div>
              </div>
            </div>
            {  assistantManager? 
            <div style={{ display: 'flex', alignItems: 'center' }}>
            <IdcardOutlined style={{ fontSize: '20px', marginRight: '16px' ,color:"#f47e46"}} />
              <div>
                <div style={{ fontWeight: 'bold' }}>Assistant Manager</div>
                <div>{assistantManager || 'Not available'}</div>
              </div>
            </div>:""}
            {userDetails?.teamId?.manager?.name?<div style={{ display: 'flex', alignItems: 'center' }}>
              <CrownOutlined style={{ fontSize: '20px', marginRight: '16px' ,color:"#f47e46"}} />
              <div>
                <div style={{ fontWeight: 'bold' }}>Manager</div>
                <div>{userDetails?.teamId?.manager?.name || 'Not available'}</div>
              </div>
            </div>:""}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <UsergroupAddOutlined style={{ fontSize: '20px', marginRight: '16px' ,color:"#f47e46"}} />
              <div>
                <div style={{ fontWeight: 'bold' }}>Team</div>
                <div>{userDetails?.teamId?.name || 'Not available'}</div>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <EnvironmentOutlined style={{ fontSize: '20px', marginRight: '16px' ,color:"#f47e46"}} />
              <div>
                <div style={{ fontWeight: 'bold' }}>Locations</div>
                <div>
                  {userDetails?.locationId?.map(locationId => locationId.name).join(', ') || 'Not available'}
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <ShopOutlined style={{ fontSize: '20px', marginRight: '16px',color:"#f47e46" }} />
              <div>
                <div style={{ fontWeight: 'bold' }}>Experience Centers</div>
                <div>
                  {experienceCenter?.map(expcenters => expcenters.name).join(', ') || 'Not available'}
                </div>
              </div>
            </div>
            
          </div>
        </DialogContent>
        <DialogActions>
          <Button  onClick={() => setProfileModal(false)} color="primary">
            Close
          </Button>
        </DialogActions>
        
       </Dialog>
             {/* Logout Confirmation Dialog */}
             <Dialog
        open={logoutConfirmModal}
        TransitionComponent={Transition}
        onClose={() => setLogoutConfirmModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Logout"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button  onClick={() => setLogoutConfirmModal(false)} color="primary">
            No
          </Button>
          <Button onClick={logout} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      </Layout>
    </Layout>

  )
})

export default connect(null, { setLoading, setSnackInfo, setUserDetails })(Sidebar)